import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import API_BASE_URL from "Components/API";
import { Link } from 'react-router-dom';
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import infographic from "Assets/Images/Multimedia/infographic.png";
import motiongraphic from "Assets/Images/Multimedia/motiongraphic.png";
import book from "Assets/Images/Multimedia/book.png";

const Multimedia = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [data, setData] = useState([]);

    const fetchData = async () => {
        const url = `${API_BASE_URL}/Media/GetMultimediaTypesCount`
        try {
            const response = await fetch(url);
            const json = await response.json();
            setData(json.results[0] || []);
        } catch (error) {
            console.error(error);
            return;
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="megaMenuContent">
            <div className="d-flex justify-content-between align-items-start gap-5">
                <div className="row h-100 col multimedia-mega-menu">
                    <div className="col-4 d-flex justify-content-center align-items-center">
                        <div className="w-100">
                            <div className="multimedia-box-img text-center">
                                <h2 className="multimedia-box-title">{t('infographics')}</h2>
                                <img src={infographic} className="mx-auto" style={{ maxWidth: 100 }} alt={t('infographics')} />
                            </div>
                            <Link to={`/Media/Multimedia/Infographic`}>{t('view_archive')}</Link>
                            <div className="text-blue item-count text-center">
                                {t('infographic_count_prefix')}{data.uploadedInfoGraphicCount || 0}{t('infographic_count_middle')}
                            </div>
                        </div>
                    </div>
                    <div className="col-4 d-flex justify-content-center align-items-center">
                        <div className="w-100">
                            <div className="multimedia-box-img text-center">
                                <h2 className="multimedia-box-title">{t('videos')}</h2>
                                <img src={motiongraphic} className="mx-auto" style={{ maxWidth: 100 }} alt={t('videos')} />
                            </div>
                            <Link to={`/Media/Multimedia/Video`}>{t('view_archive')}</Link>
                            <div className="text-blue item-count text-center">
                                {t('video_count_prefix')}{data.uploadeVideoCount || 0}{t('video_count_middle')}
                            </div>
                        </div>
                    </div>
                    <div className="col-4 d-flex justify-content-center align-items-center">
                        <div className="w-100">
                            <div className="multimedia-box-img text-center">
                                <h2 className="multimedia-box-title">{t('booklets')}</h2>
                                <img src={book} className="mx-auto" style={{ maxWidth: 100 }} alt={t('booklets')} />
                            </div>
                            <Link to={`/Media/Multimedia/Booklet`}>{t('view_archive')}</Link>
                            <div className="text-blue item-count text-center">
                                {t('booklet_count_prefix')}{data.uploadedBookletCount || 0}{t('booklet_count_middle')}
                            </div>
                        </div>
                    </div>
                </div>
                <a href="/Media/Multimedia" target="_blank" rel="noreferrer" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1">
                    {t('viewAll')}
                    <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                        {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                    </span>
                </a>
            </div>
        </div>
    );
};

export default Multimedia;